// Parsed feature Flags

interface FeatureFlag {
  prefix: string,
  name: string,
  enabled?: boolean,
  value: string,
}

// https://docs.amplify.aws/lib/auth/switch-auth/q/platform/js
type AuthenticationFlowType = 'USER_SRP_AUTH' | 'USER_PASSWORD_AUTH' | 'CUSTOM_AUTH';


export const authenticationFlowTypeFeature: AuthenticationFlowType =  import.meta.env.HGS_AUTHENTICATION_FLOW_TYPE || 'USER_PASSWORD_AUTH';

export const signUpEnabledFlag =  import.meta.env.HGS_SIGNUP_ENABLED_FLAG === 'true' ? true : false;
